/* eslint-disable no-console */

export default function (data) {
  console.log(data);
  this.$store.commit("setConfig", data);
  /*
  if (data.key === "limitTime" || data.key === "expectLastCorrect") {
    localStorage.setItem(
      `SukenDrill::${this.setting.id}_${this.drill.id}::${data.key}`,
      JSON.stringify(data.value)
    );
  } else {
    localStorage.setItem(
      `SukenDrill::${this.setting.id}::${data.key}`,
      JSON.stringify(data.value)
    );
  }
  */

  if (!data.notLS) {
    const commonSettings = ["continue", "random", "audio"];
    if (commonSettings.indexOf(data.key) !== -1) {
      localStorage.setItem(
        `SukenDrill::${this.setting.id}::${data.key}`,
        JSON.stringify(data.value)
      );
    } else {
      localStorage.setItem(
        `SukenDrill::${this.setting.id}_${this.drill.id}::${data.key}`,
        JSON.stringify(data.value)
      );
    }
  }
}